module.exports = __webpack_public_path__ + "static/media/IMG-1.c84cae8c.jpg";